import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { UserPreferences } from '@/types/preferences';

// Export the state type
export interface PreferencesState extends UserPreferences {
  isLoaded: boolean;
}

interface PreferencesActions {
  setTheme: (theme: UserPreferences['theme']) => void;
  setEmailsPerBatch: (count: number) => void;
  setAutoProcess: (enabled: boolean) => void;
  reset: () => void;
}

const defaultPreferences: UserPreferences = {
  theme: 'system',
  emailsPerBatch: 100,
  autoProcess: false,
};

export const usePreferencesStore = create<PreferencesState & PreferencesActions>()(
  persist(
    (set) => ({
      // Initial state
      ...defaultPreferences,
      isLoaded: false,

      // Actions
      setTheme: (theme) => set({ theme }),
      setEmailsPerBatch: (count) => set({ emailsPerBatch: count }),
      setAutoProcess: (enabled) => set({ autoProcess: enabled }),
      reset: () => set({ ...defaultPreferences }),
    }),
    {
      name: 'preferences-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isLoaded = true;
        }
      },
    }
  )
); 